import Vue from 'vue';
import HTTPRetryUtil from 'src/utils/httpretry';
const LabelsAPI = {
    getLabels(pageN = undefined, searchByName = '', pageSize = undefined) {
        const params = {};
        if (pageN !== undefined)
            params.page = `${pageN}`;
        if (searchByName !== '') {
            params.name = searchByName;
        }
        if (pageSize !== undefined) {
            params.page_size = `${pageSize}`;
        }
        const searchParams = new URLSearchParams(params);
        return HTTPRetryUtil.retry(`labels/?${searchParams.toString()}`);
    },
    updateLabel(id, attrs) {
        return HTTPRetryUtil.post(`labels/${id}/`, { body: attrs });
    },
    deleteLabel(id) {
        return Vue.http.delete(`labels/${id}/`).then(() => Promise.resolve(), (error) => Promise.reject(error));
    },
    createLabel(attrs) {
        return Vue.http.post('labels/', attrs).then((response) => Promise.resolve(response.json()), (error) => Promise.reject(error));
    }
};
export default LabelsAPI;
